import Vue from 'vue'
import Vuex from 'vuex'
import getDiagnosticFilesList from "@/api/files/getDiagnosticFilesList";
import getDiagnosticFile from "@/api/files/getDiagnosticFile";
import checkStatusForPending from "@/api/files/checkStatusForPending";
import timerEnd from "@/api/files/timerEnd";

Vue.use(Vuex)


const state = {
    diagnosticFilesList: [],
}
const mutations = {
    SET_DIAGNOSTIC_FILES(state, payload) {
        state.diagnosticFilesList = payload;
    },
    SET_PROCESSED_TO_FILE(state, id) {
        state.diagnosticFilesList[id].process = 'pending'
    },
    SET_NO_STARTED_TO_FILE(state, id) {
        state.diagnosticFilesList[id].process = 'no-started'
    },
    SET_DONE_TO_FILE(state, {index, item}) {
        state.diagnosticFilesList[index].process = item.status
        state.diagnosticFilesList[index].endTime = item.created_at
    }
}

const actions = {
    getDiagnosticFilesList({commit}) {
        return getDiagnosticFilesList().then((response) => {
            commit('SET_DIAGNOSTIC_FILES', response)
        })
    },
    timerEnd({commit}, {index}) {

        commit('SET_NO_STARTED_TO_FILE', index)
        return timerEnd({fid: state.diagnosticFilesList[index].study_uid});
    },
    getDiagnosticFile({commit}, payload) {
        return getDiagnosticFile(payload)
    },
    setProcessedByIndex({commit}, {index}) {
        return commit('SET_PROCESSED_TO_FILE', index)
    },
    checkStatusForPending({commit}, payload) {
        return checkStatusForPending(payload).then((response) => {
            if (response.length > 0) {
                response.forEach(item => {
                    let index = state.diagnosticFilesList.findIndex(object => {
                        return object.study_uid === item.fid;
                    });
                    commit('SET_DONE_TO_FILE', {index, item})
                });
                return 'DONE';
            }

        });
    }
}

export default {
    state,
    mutations,
    actions
}
